import React from 'react';

/**
 * Cabecera común de cada paso del wizard de reporte: botón volver (o un
 * espacio fantasma en el paso 1, que no tiene a dónde volver), indicador de
 * progreso de 5 barras, contador "N/5" y botón cerrar (X) SIEMPRE visible a
 * la derecha — antes el único botón era volver *o* cerrar, así que en los
 * pasos 2-5 el ciudadano no tenía forma directa de salir del formulario y
 * "se perdía" el botón.
 */
const StepHeader = ({ paso, onClose, onBack }) => {
  return (
    <div className="rw-step-header">
      {onBack ? (
        <button type="button" className="rw-icon-btn" onClick={onBack} aria-label="Volver">
          <i className="fas fa-arrow-left"></i>
        </button>
      ) : (
        <span className="rw-icon-btn rw-icon-btn-fantasma" aria-hidden="true"></span>
      )}

      <div className="rw-progress-bars">
        {[1, 2, 3, 4, 5].map((n) => (
          <span key={n} className={`rw-progress-bar ${n <= paso ? 'rw-progress-bar-activo' : ''}`} />
        ))}
      </div>

      <span className="rw-progress-count">{paso}/5</span>

      <button type="button" className="rw-icon-btn rw-cerrar-btn" onClick={onClose} aria-label="Cerrar formulario">
        <i className="fas fa-times"></i>
      </button>
    </div>
  );
};

export default StepHeader;
